export default __webpack_public_path__ + "static/confirmation-ppq-modal-images-6c908d8b98f6d77bc16269ef2897004d.png";